/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: true, // Change this to true if you want to use the splash screen.
  useCustomCursor: false, // Change this to false if you want the good'ol cursor
  googleTrackingID: "UA-174238252-2",
};

//Home Page
const greeting = {
  title: "Hello 👋.",
  title2: "Shah Muhammad",
  logo_name: "Shah Muhammad",
  nickname: "Shahi",
  full_name: "Shah Muhammad",
  subTitle: "Full Stack Developer, Open Source Enthusiast 🔥. Always learning.",
  resumeLink:
    "https://drive.google.com/file/d/1rM4C6tvEiwPBbHQR23Oi7DtscD4xP9o3/view?usp=share_link",
  mail: "mailto:shah.bses19@iba-suk.edu.pk",
};

const socialMediaLinks = {
  /* Your Social Media Link */
  github: "https://github.com/ShahMuhammad786",
  linkedin: "https://www.linkedin.com/in/shah-muhammad-786abc/",
  gmail: "shah.bses19@iba-suk.edu.pk",
  // gitlab: "https://gitlab.com/harikanani",
  // facebook: "https://www.facebook.com/harikrishan.kanani/",
  twitter: "https://twitter.com/ShahMuh110?t=wTggwkmGn0LV33ObQrXPCQ&s=08",
  instagram: "https://instagram.com/shahmuh110?igshid=ZDdkNTZiNTM=",
};

const skills = {
  data: [
    {
      title: "Full Stack Development",
      fileName: "FullStackImg",
      skills: [
        "⚡ Develop highly interactive Front end / User Interfaces for your web and mobile applications",
        "⚡ Building responsive website front end using ReactJS",
        "⚡ Developing mobile applications using Flutter and Android",
        "⚡ Creating application backend in Node, Express",
        "⚡ Integration of third party services such as Firebase",
      ],
      softwareSkills: [
        {
          skillName: "HTML5",
          fontAwesomeClassname: "simple-icons:html5",
          style: {
            color: "#E34F26",
          },
        },
        {
          skillName: "CSS3",
          fontAwesomeClassname: "fa-css3",
          style: {
            color: "#1572B6",
          },
        },
        {
          skillName: "JavaScript",
          fontAwesomeClassname: "simple-icons:javascript",
          style: {
            backgroundColor: "#FFFFFF",
            color: "#F7DF1E",
          },
        },
        // {
        //   skillName: "PHP",
        //   fontAwesomeClassname: "simple-icons:php",
        //   style: {
        //     color: "#7377AD",
        //   },
        // },
        {
          skillName: "ReactJS",
          fontAwesomeClassname: "simple-icons:react",
          style: {
            color: "#61DAFB",
          },
        },
        {
          skillName: "NodeJS",
          fontAwesomeClassname: "simple-icons:node-dot-js",
          style: {
            color: "#339933",
          },
        },
        {
          skillName: "NPM",
          fontAwesomeClassname: "simple-icons:npm",
          style: {
            color: "#CB3837",
          },
        },
        {
          skillName: "MongoDB",
          fontAwesomeClassname: "simple-icons:mongodb",
          style: {
            color: "#439743",
          },
        },
        // {
        //   skillName: "GraphQL",
        //   fontAwesomeClassname: "simple-icons:graphql",
        //   style: {
        //     color: "#DE33A6",
        //   },
        // },
        {
          skillName: "Android",
          fontAwesomeClassname: "simple-icons:android",
          style: {
            color: "#3DDC84",
          },
        },
        {
          skillName: "Java",
          fontAwesomeClassname: "simple-icons:java",
          style: {
            color: "#f89820",
          },
        },
        {
          skillName: "Flutter",
          fontAwesomeClassname: "simple-icons:flutter",
          style: {
            color: "#02569B",
          },
        },
        {
          skillName: "Dart",
          fontAwesomeClassname: "simple-icons:dart",
          style: {
            color: "#29B0EE",
          },
        },
        // {
        //   skillName: "Visual Basic",
        //   fontAwesomeClassname: "simple-icons:dot-net",
        //   style: {
        //     color: "#029FCE",
        //   },
        // },
        {
          skillName: "MySQL",
          fontAwesomeClassname: "simple-icons:mysql",
          style: {
            color: "#4479A1",
          },
        },
        {
          skillName: "jQuery",
          fontAwesomeClassname: "simple-icons:jquery",
          style: {
            color: "#0865A6",
          },
        },
        // {
        //   skillName: "Wordpress",
        //   fontAwesomeClassname: "simple-icons:wordpress",
        //   style: {
        //     color: "#207297",
        //   },
        // },
        // {
        //   skillName: "Apache",
        //   fontAwesomeClassname: "simple-icons:apache",
        //   style: {
        //     color: "#CA1A22",
        //   },
        // },
        {
          skillName: "Git",
          fontAwesomeClassname: "simple-icons:git",
          style: {
            color: "#E94E32",
          },
        },
        // {
        //   skillName: "C",
        //   fontAwesomeClassname: "simple-icons:c",
        //   style: {
        //     color: "#E94E32",
        //   },
        // },
        {
          skillName: "C++",
          fontAwesomeClassname: "simple-icons:cplusplus",
          style: {
            color: "#E94E32",
          },
        },
        {
          skillName: "Python",
          fontAwesomeClassname: "simple-icons:python",
          style: {
            color: "#3776AB",
          },
        },
      ],
    },
    {
      title: "Cloud Infra-Architecture",
      fileName: "CloudInfraImg",
      skills: [
        "⚡ Experience working on multiple cloud platforms",
        "⚡ Experience hosting and managing websites",
        // "⚡ Experience with Continuous Integration",
      ],
      softwareSkills: [
        // {
        //   skillName: "AWS",
        //   fontAwesomeClassname: "simple-icons:amazonaws",
        //   style: {
        //     color: "#FF9900",
        //   },
        // },
        {
          skillName: "Netlify",
          fontAwesomeClassname: "simple-icons:netlify",
          style: {
            color: "#38AFBB",
          },
        },
        {
          skillName: "Heroku",
          fontAwesomeClassname: "simple-icons:heroku",
          style: {
            color: "#6863A6",
          },
        },
        {
          skillName: "Firebase",
          fontAwesomeClassname: "simple-icons:firebase",
          style: {
            color: "#FFCA28",
          },
        },
        // {
        //   skillName: "PostgreSQL",
        //   fontAwesomeClassname: "simple-icons:postgresql",
        //   style: {
        //     color: "#336791",
        //   },
        // },
        {
          skillName: "MongoDB",
          fontAwesomeClassname: "simple-icons:mongodb",
          style: {
            color: "#47A248",
          },
        },
        // {
        //   skillName: "Docker",
        //   fontAwesomeClassname: "simple-icons:docker",
        //   style: {
        //     color: "#1488C6",
        //   },
        // },
        {
          skillName: "GitHub Actions",
          fontAwesomeClassname: "simple-icons:githubactions",
          style: {
            color: "#5b77ef",
          },
        },
      ],
    },
  ],
};

const degrees = {
  degrees: [
    {
      title: "Sukkur IBA University",
      subtitle: "Bachelor in Computer Science",
      logo_path: "siba.png",
      alt_name: "SIBAU",
      duration: "Feb 2019 - Feb 2023",
      descriptions: [
        "⚡ I have done my bachelors in Computer Science.",
        "⚡ I have studied core subjects like Data Structures, DBMS, Networking, Security, etc.",
        "⚡ I have also completed various courses for Backend , Web Engineering, Enterprise App Development, Mobile App Development, etc.",
        "⚡ I have implemented several projects based on what I've leart under my Computer Engineering course. ",
      ],
      website_link: "https://www.iba-suk.edu.pk/",
    },
  ],
};

const certifications = {
  certifications: [
    {
      title: "Advance React",
      subtitle: "Meta",
      logo_path: "reactjs.png",
      certificate_link:
        "https://drive.google.com/file/d/1ngEHzoTxRxR9h-EpUvz3JH9QcdB6E8mn/view?usp=share_link",
      alt_name: "meta",
      // color_code: "#2AAFED",
      color_code: "#00bfff",
    },
    {
      title: "React Basics",
      subtitle: "Meta",
      logo_path: "reactjs.png",
      certificate_link:
        "https://drive.google.com/file/d/1HsXYSr6qtOW_bvyclwnyw688Nf9L4BPA/view?usp=share_link",
      alt_name: "react basics",
      color_code: "#00bfff",
    },
    {
      title: "RESTful APIs",
      subtitle: "NIIT",
      logo_path: "apis.png",
      certificate_link:
        "https://drive.google.com/file/d/1tzjqV9q1JXhNRH6Dtd7_rKLqa7rJKJ1d/view?usp=share_link",
      alt_name: "NIIT",
      // color_code: "#F6B808",
      color_code: "#47A048",
    },
    {
      title: "Server Side JavaScript",
      subtitle: "NIIT",
      logo_path: "nodejs.png",
      certificate_link:
        "https://drive.google.com/file/d/1oolSv8_e6JpfV34axmXLAUZP_DyN6gdH/view?usp=share_link",
      alt_name: "NIIT",
      color_code: "#47A048",
    },
    {
      title: "Programming with JS",
      subtitle: "Meta",
      logo_path: "js.png",
      certificate_link:
        "https://drive.google.com/file/d/1GQdXmatwdCigEWidxZBIckfyzIQmI91V/view?usp=share_link",
      alt_name: "Meta",
      color_code: "goldenrod",
    },
    {
      title: "Front End Development",
      subtitle: "Meta",
      logo_path: "frontend.png",
      certificate_link:
        "https://drive.google.com/file/d/10jI2YQq-hYr_pGljLZztSAuXr9ckYK28/view?usp=share_link",
      alt_name: "Meta",
      color_code: "tomato",
    },
    {
      title: "Intro to SQL",
      subtitle: "DataCamp",
      logo_path: "mysql.png",
      certificate_link:
        "https://drive.google.com/file/d/19CnzFt_xWo0Vd92GzBOg2zJ5SjYf66jY/view?usp=share_link",
      alt_name: "sql",
      // color_code: "#f36c3d",
      color_code: "#fffbf3",
    },
    {
      title: "Joins in SQL",
      subtitle: "DataCamp",
      logo_path: "sql.png",
      certificate_link:
        "https://drive.google.com/file/d/1aueoG73WMX6_kqrbQi1isPrdPmj7dmO7/view?usp=share_link",
      alt_name: "sql",
      color_code: "#f06c2d",
      // color_code: "#fffbf3",
    },
    {
      title: "Triggers in SQL",
      subtitle: "DataCamp",
      logo_path: "mysql.png",
      certificate_link:
        "https://drive.google.com/file/d/1KW0rybMXYmRjyyEWA0etn7ezUseQlxj7/view?usp=share_link",
      alt_name: "sql",
      // color_code: "#f36c3d",
      color_code: "#fffbf3",
    },
    // color_code: "#8C151599",
    // color_code: "#7A7A7A",
    // color_code: "#0C9D5899",
    // color_code: "#C5E2EE",
    // color_code: "#ffc475",
    // color_code: "#g",
    // color_code: "#ffbfae",
    // color_code: "#fffbf3",
    // color_code: "#b190b0",
  ],
};

// Experience Page
const experience = {
  title: "Experience",
  subtitle: "Work, Internship and Volunteership",
  description:
    "I've completed one internship. I've mostly done projects on my own and I am actively looking for internships / Jobs. I love organizing workshops to share my knowledge with others.",
  header_image_path: "experience.svg",
  sections: [
    {
      title: "Work Experience",
      experiences: [
        {
          title: "FullStack Trainee",
          company: "SkipQ",
          company_url: "https://www.skipq.org/",
          logo_path: "skipq.png",
          duration: "Sep 2022 - Present",
          location: "USA, Remote",
          description: `
          ⚡ Best coding practices, data structures to solve problems, and communication skills. 
          ⚡ Hands-on expertise in React, Nodejs, Expressjs, RESTful APIs, JavaScript, Redux.
          ⚡ Built a MERN full stack App with a backend and CRUD API functionality.
          ⚡ GitHub Versioning, Code Reviews, MongoDB, API Gateway, Express, React and Material UI.
          ⚡ Did multiple certifications and upgraded time management skills.
          `,
          // "I worked on the Dashboard project which helps users track their activities while using Walo Application. I also worked on Ocean Inventory Application and it's Admin panel Backend as well as on Ocean Inventory Admin Front-end using React and also worked on Walo Admin Backend.",
          color: "#0071C5",
        },
        {
          title: "Junior Software Developer",
          company: "Columbia Fitness",
          company_url: "https://columbiafitness.com/",
          logo_path: "columbia.png",
          duration: "Sep 2022 - Feb 2023",
          location: "Kennewick, US, Remote",
          description: `
          ⚡ Mainly worked on projects related to hardware and software and different cutting edge technologies.
          ⚡ One of the project that I have worked on was a remote Door Access Control Software, An IoT based Project
          consists of Android App, iOS App, Windows App, Cloud
          Database (Firebase), Hardware (Arduino Uno / Arduino
          Leonardo / relays etc.)
          `,
          // "I worked on the Dashboard project which helps users track their activities while using Walo Application. I also worked on Ocean Inventory Application and it's Admin panel Backend as well as on Ocean Inventory Admin Front-end using React and also worked on Walo Admin Backend.",
          color: "#0071C5",
        },
        {
          title: "Full Stack Developer (Freelancer)",
          company: "Fiverr",
          company_url: "https://www.fiverr.com/shah_m110",
          logo_path: "fiverr.png",
          duration: "Sep 2021 - Present",
          location: "Work From Home",
          description: `
          ⚡ Maintain close contact with the client and team when handling change requests.
          ⚡ Java and C# and Electron.js is used for the Desktop applications.
          ⚡ ReactJS is used for the Frontend.
          ⚡ NodeJS is used for the Backend.
          ⚡ MongoDB is used for the Database.
          ⚡ Flutter and Firebase is used for the Authentication and mobile applications
          `,
          // "Created Front end of Yearn Financial Mutual Funds website. also degined simple web application for better user experience, designed DB Schemas as well.",
          color: "#ee3c26",
        },
      ],
    },
    {
      title: "Volunteerships",
      experiences: [
        {
          title: "Deputy Speaker National Youth Assembly",
          company: "SIBAU",
          company_url: "https://www.iba-suk.edu.pk/",
          logo_path: "youth.jpg",
          duration: "2021 - 2022",
          location: "Sukkur, Pakistan",
          description:
            "As a Deputy Speaker, I was responsible for organizing the National Youth Assembly and making sure that the event is a success.",
          color: "#FBBD18",
        },
        {
          title: "Active Member of Sports & Adventure Society",
          company: "SIBAU",
          company_url: "https://www.iba-suk.edu.pk/",
          logo_path: "sports.jpg",
          duration: "Nov 2021 - June 2022",
          location: "Sukkur, Pakistan",
          description:
            "As an Active Member of Sports & Adventure Society, I was responsible for organizing the events and making sure that the event is a success.",
          color: "#4285F4",
        },        
        {
          title: "Active Member of Computer Society",
          company: "SIBAU",
          company_url: "https://www.iba-suk.edu.pk/",
          logo_path: "computer.png",
          duration: "Nov 2021 - June 2022",
          location: "Sukkur, Pakistan",
          description:
            "As an Active Member of Computer Society, I was responsible for organizing the events and making sure that the event is a success.",
          color: "#D83B01",
        },
        {
          title: "Sukkur IBA Ambassador",
          company: "SIBAU",
          company_url: "https://www.iba-suk.edu.pk/",
          logo_path: "siba.png",
          duration: "Feb 2019 - Feb 2021",
          location: "Work From Home",
          description:
            "As a Sukkur IBA Ambassador, I was responsible for organizing the events and making sure that the event is a success. In those events, I was there to spread awareness about the university, Scholarships like NTHP, THP, STHP etc and its programs.", 
          color: "#D83B01",
        },        
      ],
    },
  ],
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "My projects make use of a vast variety of latest technology tools. My best experience is to create NodeJS Backend Projects, Python Scripts, Java Projects and React Project. Below are some of my projects. Note that not all of the mentioned projects are on GitHub yet.",
  avatar_image_path: "projects_image.svg",
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "shahwork.png",
    description:
      "You can contact me at the places mentioned below. I will try to get back to you as fast as I can. ",
  },
  blogSection: {
    title: "Blogs",
    subtitle:
      "I don't blog frequently but when I do something awesome, I do try to document it so it can be helpful to others. I write on Twitter.",
    link: "https://twitter.com/ShahMuh110?t=wTggwkmGn0LV33ObQrXPCQ&s=08",
    avatar_image_path: "blogs_image.svg",
  },
};

const projects = {
  data: [
    {
      id: "0",
      name: "Trans-Ethers",
      url: "https://transethers.netlify.app/",
      description:
        "Web 3.0 app, which used to transfer Ethereum from one wallet to another using Metamask wallet. Ethers transferred real-time with a gas fees on a Goerli test network.",
      languages: [
        {
          name: "JavaScript",
          iconifyClass: "logos-javascript",
        },
        {
          name: "ReactJS",
          iconifyClass: "logos-react",
        },
        {
          name: "Solidity",
          iconifyClass: "logos-solidity",
        },  
        {
          name: "Tailwind CSS",
          iconifyClass: "bxl:tailwind-css",
        },    
        {
          name: "Alchemy",
          iconifyClass: "simple-icons:alchemy",
        },         
        {
          name: "Giphy API",
          iconifyClass: "simple-icons:giphy",
        },
      ],
      links: [
        {
          name: "Github",
          url: "https://github.com/ShahMuhammad786/Eth-Transections-n-BC---Web-3.0-App",
          iconifyClass: "ri:github-fill",
        },        
        {
          name: "Live Demo",
          url: "https://transethers.netlify.app/",
          iconifyClass: "mdi:web",
        },
      ],
    },
    {
      id: "1",
      name: "Youtube Clone",
      url: "https://youtube-clone-pk.netlify.app/",
      description:
        "A web based application just like youtube using ReactJS and RapidAPI.",
      languages: [
        {
          name: "JavaScript",
          iconifyClass: "logos-javascript",
        },
        {
          name: "ReactJS",
          iconifyClass: "logos-react",
        },
        {
          name: "Rapid API",
          iconifyClass: "tabler:api",
        },
        {
          name: "Material UI",
          iconifyClass: "logos-material-ui",
        },
      ],
      links: [
        {
          name: "Github",
          url: "https://github.com/ShahMuhammad786/youtube_clone_reactJS_rapidApi",
          iconifyClass: "ri:github-fill",
        },
        {
          name: "Live Demo",
          url: "https://youtube-clone-pk.netlify.app/",
          iconifyClass: "mdi:web",
        },
      ],
    },
    {
      id: "2",
      name: "Mess Management System",
      url: "https://mms-bitycodz.netlify.app/main/dashboard",
      description:
        "A complete solution for the mess activities. The current version is just the front-end",
      languages: [
        {
          name: "JavaScript",
          iconifyClass: "logos-javascript",
        },
        {
          name: "ReactJS",
          iconifyClass: "logos-react",
        },
        {
          name: "Ant Design",
          iconifyClass: "logos-ant-design",
        },
        {
          name: "Fusion Charts",
          iconifyClass: "ep:trend-charts",
        },
      ],
      links: [
        {
          name: "Github",
          url: "https://github.com/ShahMuhammad786/Mess-Management-System-Reactjs",
          iconifyClass: "ri:github-fill",
        },        
        {
          name: "Live Demo",
          url: "https://mms-bitycodz.netlify.app/main/dashboard",
          iconifyClass: "mdi:web",
        },
      ],
    },
    {
      id: "3",
      name: "CodeX - AI",
      url: "https://codex-openai-app.vercel.app/",
      description:
        "A clone of ChatGPT using OpenAI GPT model text-davinci-003.",
      languages: [
        {
          name: "JavaScript",
          iconifyClass: "logos-javascript",
        },
        {
          name: "ReactJS",
          iconifyClass: "logos-react",
        },
        {
          name: "NodeJs",
          iconifyClass: "logos-nodejs",
        },
        {
          name: "ExpressJs",
          iconifyClass: "skill-icons:expressjs-dark",
        },
        {
          name: "CSS3",
          iconifyClass: "logos-css-3",
        },
      ],
      links: [
        {
          name: "Github",
          url: "https://github.com/ShahMuhammad786/CodeX-openai-app",
          iconifyClass: "ri:github-fill",
        },
        {
          name: "Live Demo",
          url: "https://codex-openai-app.vercel.app/",
          iconifyClass: "mdi:web",
        },
      ],
    },
    {
      id: "4",
      name: "Face Recognition Using One Shot Learning",
      url: "https://github.com/ShahMuhammad786/FaceRecognition-Using-OneShotLearning-Machine-Learning-",
      description:
        "This project is based on the concept of One Shot Learning. It is a machine learning project which is used to recognize the face of a person.",
      languages: [
        {
          name: "Python",
          iconifyClass: "logos-python",
        },
        {
          name: "Keras",
          iconifyClass: "simple-icons:keras",
        },
        {
          name: "OpenCV",
          iconifyClass: "logos-opencv",
        },
        {
          name: "Numpy",
          iconifyClass: "logos-numpy"          
        },
        {
          name: "Matplotlib",
          iconifyClass: "logos:matplotlib-icon",
        },

      ],
      links: [
        {
          name: "Github",
          url: "https://github.com/ShahMuhammad786/FaceRecognition-Using-OneShotLearning-Machine-Learning-",
          iconifyClass: "ri:github-fill",
        },        
      ],
    },
    {
      id: "5",
      name: "Mouse Control Remotely with Python and MediaPipe by Google",
      url: "https://github.com/ShahMuhammad786/Mouse-Control-remotely-Project-using-Python-and-MediaPipe-by-Google",
      description:
        "This project is based on the concept of MediaPipe by Google. It is a machine learning project which is used to control the mouse remotely.", 
      languages: [
        {
          name: "Python",
          iconifyClass: "logos-python",
        },
        {
          name: "MediaPipe",
          iconifyClass: "cib:google",
        },        
      ],
      links: [
        {
          name: "Github",
          url: "https://github.com/ShahMuhammad786/Mouse-Control-remotely-Project-using-Python-and-MediaPipe-by-Google",
          iconifyClass: "ri:github-fill",
        },        
      ],
    },
    {
      id: "6",
      name: "Web Based Arithmatic Compiler",
      url: "https://github.com/ShahMuhammad786/A-web-based-compiler---Compiler-Construction-project",
      description:
        "This project is based on the concept of Compiler Construction. It parse and calculate the artithematic expressions.",  
      languages: [
        {
          name: "HTML5",
          iconifyClass: "vscode-icons:file-type-html",
        },
        {
          name: "CSS3",
          iconifyClass: "vscode-icons:file-type-css",
        },
        {
          name: "JavaScript",
          iconifyClass: "logos-javascript",
        },
        {
          name: "Bootstrap",
          iconifyClass: "logos-bootstrap",
        },
      ],
      links: [
        {
          name: "Github",
          url: "https://github.com/ShahMuhammad786/A-web-based-compiler---Compiler-Construction-project",
          iconifyClass: "ri:github-fill",
        },
        
      ],
    },
    {
      id: "7",
      name: "Point Of Sale Project using .NET CSharp and SQL",
      url: "https://github.com/ShahMuhammad786/Point-Of-Sale-Project-using-.NET-CSharp-and-SQL",
      description:
        "This project is based on the concept of Point Of Sale. It is a desktop application which is used to manage the sales of a shop.",  
      languages: [
        {
          name: "C#",
          iconifyClass: "logos-c-sharp",
        },
        {
          name: "SQL",
          iconifyClass: "logos:mysql",
        },
        
      ],
      links: [
        {
          name: "Github",
          url: "https://github.com/ShahMuhammad786/Point-Of-Sale-Project-using-.NET-CSharp-and-SQL",
          iconifyClass: "ri:github-fill",
        },
      ],
    },
    {
      id: "8",
      name: "Process Schedular Project in Java Operating System",
      url: "https://github.com/ShahMuhammad786/Process-Schedular-Project-in-Java-Operating-System",
      description:
        "This project is based on the concept of Operating System. It is a desktop application which is used to schedule the processes of a Operating System.",
      languages: [
        {
          name: "Java",
          iconifyClass: "logos-java",
        },
        
      ],
      links: [
        {
          name: "Github",
          url: "https://github.com/ShahMuhammad786/Process-Schedular-Project-in-Java-Operating-System",
          iconifyClass: "ri:github-fill",
        },
      ],
    },
    
  ],
};

export {
  settings,
  greeting,
  socialMediaLinks,
  skills,
  degrees,
  certifications,
  experience,
  projectsHeader,
  contactPageData,
  projects,
};
